import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { UserModel } from '../../models/platform/userModel';
import { AccountModel } from '../../models/platform/accountModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class UserApi {

    async getUser() {
        try {
            const response = await axios.get(`${API_URL}/api/users`,
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }
    
    async updatePassword(current_password: string, new_password: string) {
        try {
            const payload =
            {
                current_password,
                new_password,
            };

            const response = await axios.patch(`${API_URL}/api/users/change-password`, payload, {
                headers: authHeader(),
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

    async updateUser(first_name: string, last_name: string, title: string, phone_number: string) {
        try {
            const payload =
            {
                first_name,
                last_name,
                title,
                phone_number
            };

            const response = await axios.post(`${API_URL}/api/users`, payload, {
                headers: authHeader(),
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

    async requestEmailUpdate(email: string) {
        try {
            const payload =
            {
                email,
            };

            const response = await axios.post(`${API_URL}/api/users/email/request-update`, payload, {
                headers: authHeader(),
            });

            return response.data as ResponseSuccessModel;
        }
        catch (error) {
            return handleAxiosError(error);
        }
    }

}

const userApi = new UserApi();
export default userApi;
